<template>
  <donut-modal
    v-model="isOpen"
    :cancelable="true"
    :button="null"
  >
    <div class="f-v f-ast">
      <donut-modal-sections-title
        category="warn"
        :title="`Remove ${channelDisplayName} from Team Pulse?`"
      />
      <div class="t">
        <p class="m-bx2">
          Are you sure? If you remove this channel, you will lose access to all
          its participation and sentiment history in your dashboard.
        </p>
        <p>
          To see this data again later, you’ll have to re-add the channel and
          wait up to 24 hours for Donut to re-analyze the pulse.
        </p>
      </div>
    </div>
    <template #actions>
      <a
        class="link p m-r"
        :class="{ disabled: isRemoving }"
        @click="onCancel"
      >Cancel</a>
      <donut-button
        class="red inv"
        :class="{ disabled: isRemoving, loading: isRemoving }"
        :disabled="isRemoving"
        @click="confirmRemove"
      >
        Remove channel
      </donut-button>
    </template>
  </donut-modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Network from 'lib/api/network';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  channelId: {
    type: Number,
    required: true,
  },
  channelDisplayName: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const store = useStore();

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const isRemoving = ref(false);

const onCancel = () => {
  if (isRemoving.value) return;
  isOpen.value = false;
};

const confirmRemove = () => {
  if (isRemoving.value) return;

  isRemoving.value = true;
  Network.patch(`/team_pulse/channels/${props.channelId}/disable_pulse`, {}, {
    success: () => {
      isOpen.value = false;
      window.location.assign('/team_pulse');
    },
    error: () => {
      store.dispatch('setErrorToast', 'Unable to remove this channel from Team Pulse. Please try again.');
    },
    complete: () => {
      isRemoving.value = false;
    },
  });
};
</script>
